<template>
  <layout>
    <page-header :header="$t('vehicles.vehicle_types.create')">
    </page-header>
    <div class="content">
      <resource-form
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'vehicle-types'

export default {
  name: 'VehicleTypeCreate',

  components: {
    ResourceForm,
  },

  data() {
    return {
    }
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
    onActionClick(action) {
      this.rideType = action.rideType
    },
  },
}
</script>
